(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.cacheShippingBannerHeight();
      this.onResizeCacheShipping = this.cacheShippingBannerHeight.bind(this);
      window.addEventListener('resize', this.onResizeCacheShipping);
      this.updateStickyShippingState(window.pageYOffset || document.documentElement.scrollTop);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    cacheShippingBannerHeight() {
      const topBannerBar = document.querySelector('.shipping-marquee-banner-section .shipping-marquee-banner__bar');
      let bannerHeight = 0;

      if (topBannerBar && topBannerBar.offsetHeight > 0) {
        bannerHeight = Math.ceil(topBannerBar.offsetHeight);
      }

      if (!bannerHeight) {
        const cssHeight = parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--shipping-banner-height')
        );
        if (!Number.isNaN(cssHeight) && cssHeight > 0) {
          bannerHeight = Math.ceil(cssHeight);
        }
      }

      if (bannerHeight > 0) {
        this._shippingBannerHeight = bannerHeight;
      }
    }

    getShippingScrollThreshold() {
      if (!this._shippingBannerHeight) {
        this.cacheShippingBannerHeight();
      }
      return this._shippingBannerHeight || 24;
    }

    updateStickyShippingState(scrollTop) {
      const enterThreshold = this.getShippingScrollThreshold();
      const exitThreshold = Math.max(enterThreshold - 12, 0);
      const isScrolled = this._wasShippingScrolled
        ? scrollTop >= exitThreshold
        : scrollTop >= enterThreshold;

      document.body.classList.toggle('header-is-scrolled', isScrolled);
      this.classList.toggle('header-wrapper--scrolled', isScrolled);

      const stickyShipping = this.querySelector('.header__sticky-shipping');
      if (stickyShipping) {
        const ariaHidden = isScrolled ? 'false' : 'true';
        if (stickyShipping.getAttribute('aria-hidden') !== ariaHidden) {
          stickyShipping.setAttribute('aria-hidden', ariaHidden);
        }
      }

      if (isScrolled !== this._wasShippingScrolled) {
        this._wasShippingScrolled = isScrolled;
        requestAnimationFrame(() => this.setHeaderHeight());

        if (isScrolled) {
          this.scheduleInnerMarqueeInit();
        } else {
          this._innerMarqueeInitScheduled = false;
        }

        setTimeout(() => this.setHeaderHeight(), 280);
      }
    }

    scheduleInnerMarqueeInit() {
      if (this._innerMarqueeInitScheduled) return;
      this._innerMarqueeInitScheduled = true;

      let attempts = 0;
      const tryInit = () => {
        const ready = window.BirtzShippingMarquee?.initInnerHeaderMarquee?.();
        if (ready) {
          this.setHeaderHeight();
          return;
        }
        attempts += 1;
        if (attempts < 12) {
          window.setTimeout(tryInit, 50);
        }
      };

      window.requestAnimationFrame(tryInit);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onResizeCacheShipping);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      this.updateStickyShippingState(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
